import {createRouter, createWebHistory} from 'vue-router';
import Idle from '@/views/user/Idle';
import Order from '@/views/user/Order';
import Payment from '@/views/user/Payment';
import BellSelect from '@/views/user/BellSelect';
import Pickup from '@/views/user/Pickup';

import App from '@/App';

const routes = [
  {path: '/setting/data', name: 'app', component: App}, //사원 로그인

  // 사용자 화면
  {path: '/user/idle', name: 'idle', component: Idle}, //대기화면
  {path: '/user/order', name: 'order', component: Order}, //주문
  {path: '/user/order/:id', name: 'order-detail', component: Order}, //주문상세
  {path: '/user/payment', name: 'payment', component: Payment}, //결제
  {path: '/user/bell/select/:tran', name: 'bell-select', component: BellSelect, props: true}, //결제 알림
  {path: '/user/pickup', name: 'pickup', component: Pickup}, //픽업
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  toggleProgressIcon(true);
  next();
});

router.afterEach(() => {
  toggleProgressIcon(false);
});

function toggleProgressIcon(isShow) {
  let body = document.querySelector('body');
  if (body) {
    let divTag = body.querySelector('.progress-icon-wrap');
    if (divTag) divTag.remove();

    if (isShow) {
      let divWrapTag = document.createElement('div');
      divWrapTag.classList = 'progress-icon-wrap';

      let divTag = document.createElement('div');
      divTag.classList = 'progress-icon';

      divWrapTag.append(divTag);

      body.append(divWrapTag);
    }
  }
}

export default router;
